<template>
  <div>
    <h2 class="fw-bold mb-4">Stanowiska w Lokalu</h2>
    <div class="row g-3">
      <div v-for="space in spaces" :key="space.id" class="col-sm-6 col-lg-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body">
            <h5 class="card-title fw-bold text-warning">
              <font-awesome-icon icon="fa-solid fa-bullseye" class="me-2" />
              {{ space.name }}
            </h5>
            <p class="card-text text-muted small mb-3">ID: {{ space.id }}</p>
            <span class="badge bg-success">Dostępne</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminSpaces',
  data() {
    return {
      spaces: [
        { id: 1, name: 'Stanowisko 1' },
        { id: 2, name: 'Stanowisko 2' },
        { id: 3, name: 'Stanowisko 3' },
        { id: 4, name: 'Stanowisko 4' },
        { id: 5, name: 'Stanowisko 5' }
      ]
    }
  }
}
</script>